module.exports = __webpack_public_path__ + "static/media/Contactphone.089a0f8a.svg";